import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const HowItWorks = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const steps = [
    {
      number: '1',
      title: t.howItWorks.step1.title,
      description: t.howItWorks.step1.description,
      details: t.howItWorks.step1.details,
      image: '/images/step1-take-photo.jpg',
    },
    {
      number: '2',
      title: t.howItWorks.step2.title,
      description: t.howItWorks.step2.description,
      details: t.howItWorks.step2.details,
      image: '/images/step2-ai-analysis.jpg',
    },
    {
      number: '3',
      title: t.howItWorks.step3.title,
      description: t.howItWorks.step3.description,
      details: t.howItWorks.step3.details,
      image: '/images/step3-get-recipes.jpg',
    },
  ];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.howItWorks.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.howItWorks.subtitle}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="mb-6 rounded-xl overflow-hidden shadow-lg">
                <img 
                  src={step.image} 
                  alt={step.title}
                  className="w-full h-48 object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div 
                  className="w-full h-48 bg-gradient-to-br from-purple-600 to-indigo-800 flex items-center justify-center text-white text-6xl"
                  style={{ display: 'none' }}
                >
                  {step.number}
                </div>
              </div>
              <div className="w-20 h-20 bg-gradient-to-br from-purple-600 to-indigo-800 text-white rounded-full flex items-center justify-center text-4xl font-bold mx-auto mb-6 shadow-lg">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {step.title}
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                {step.description}
              </p>
              <p className="text-gray-600 text-sm leading-relaxed">
                {step.details}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
